import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { useEffect, useState } from 'react';
import en from '../../lang/en-us';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import {
    updateDividend,
    verifyChangeEmailOTP as verifyOTP,
    sendPhoneOTP,
} from '../../redux-store/actions/nct';
import { connect } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { OTP_ACTIONS } from '../../utils/constants';
import { maskMobileNumber } from '../../utils/utilityFunctions';
import { ActionHeader } from '../dashboard/makeNct';
import { SubmitButtonWithLoader } from '../../lib/Button';
import { onResetDevices } from '../../redux-store/actions/mobile';
import { ResetDevicePayload } from '../../redux-store/types/mobile';
import { getPlatformWisePayload } from '../../redux-store/middleware';
const { dashboard, common } = en;

const initState = {
    otp: null,
    reqId: null,
    otpRef: null,
};

function ResetDeviceOtp(props: any) {
    const { mobile } = props;
    const [otpInput, setOtp] = useState<any>(new Array(6).fill(''));
    const [count, setCount] = useState(0);
    const [{ otp, reqId, otpRef }, setOtpInfo] = useState(initState);
    const { timer, startTimer, resetTimer } = useTimer({});
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [reset, setReset] = useState<boolean>(false);

    useEffect(() => {
        const { otp, reqId, otpRef } = props.location.state || {};
        // if (!mobile) {
        //     props.history.push('/');
        //     return;
        // }
        setOtpInfo({
            otp,
            reqId,
            otpRef,
        });
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        const { METADATA: metaData } = getPlatformWisePayload();
        try {
            const { pan, pekrn } = props;
            const { selectedDevices } = props.location.state || {};
            const payload = {
                enteredOtp: otpInput.join(''),
                otpRef,
                reqId,
                pan,
                pekrn,
                action: OTP_ACTIONS.RESET_DEVICE,
            };

            let res = await props.verifyOTP(payload);
            if (res.status === 200) {
                const body: ResetDevicePayload = {
                    pan,
                    metaData,
                    mobile: props.mobile,
                    email: props.email || '',
                    pekrn,
                    ids: selectedDevices,
                };
                let res = await props.onResetDevices(body);
                if (res) {
                    setReset(true);
                    setTimeout(() => {
                        setReset(false);
                        props.history.goBack();
                    }, 2000);
                }
            }
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const onResend = async () => {
        try {
            const { pan, pekrn } = props;
            let payload = { pan, pekrn, action: OTP_ACTIONS.RESET_DEVICE };
            let res = await props.sendPhoneOTP(payload);
            setShowModal(true);
            setOtpInfo({ ...(res || {}).body });
            setOtp(new Array(6).fill(''));
            resetTimer();
        } catch (err: any) {
            alert(err.message);
        }
    };

    return (
        <div className="mobile_mode login-auth set-pin reset-devices">
            <div className="logo">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back"
                    onClick={() => props.history.goBack()}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.goBack();
                        }
                    }}
                >
                    <img
                        src="/images/left-arrow-white.svg"
                        alt=""
                        aria-hidden="true"
                    />
                </a>
                <h3>
                    {common.resetDevices.resetTxt} {common.resetDevices.devicesTxt}
                </h3>
            </div>
            <div className="login-auth-content">
                <h3 className="subheading">
                    {dashboard.OtpScreen.subHeading}
                    <span>{dashboard.OtpScreen.subHeadingSpan}</span>
                </h3>
                <p>
                    {mobile
                        ? dashboard.OtpScreen.otpPhoneSubject
                        : dashboard.OtpScreen.subHeadingInfo}{' '}
                    <span>{mobile ? maskMobileNumber(mobile) : props.email}</span>
                </p>
                <OtpField
                    value={otpInput}
                    updateValue={(otp: string[]) => {
                        setCount(count + 1);
                        setOtp(otp);
                    }}
                    maskedInfo={`Please enter the 6-digit OTP sent to  ${maskMobileNumber(mobile)}`}
                    showModal={showModal}
                    _handleProceed={() => setShowModal(false)}
                />
                <div className="curved-bg-content-inner-bottom">
                    <SubmitButtonWithLoader
                        disabled={otpInput.join('').length !== 6}
                        loading={loading}
                        label={dashboard.OtpScreen.buttonText}
                        labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                        onClick={handleSubmit}
                        fullWidth
                    />
                    <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
                </div>
            </div>
            <Dialog maxWidth={'sm'} open={loading} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p>{'Successfully Removed Devices.'}</p>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { verifyOTP, sendPhoneOTP, onResetDevices },
)(ResetDeviceOtp);
